module.exports = __webpack_public_path__ + "static/media/photo5.6c0419e2.jpg";